import type { Action } from '@ngrx/store';
import type { ReferenceListItem, ReferenceListName } from '../reference-lists.interface';

// kept for legacy combined lists
export enum ActionType {
    FETCH_REFERENCE_LISTS_SUCCEEDED = '[REFERENCE-LISTS] FETCH_REFERENCE_LISTS_SUCCEEDED'
}

export class FetchReferenceListsSucceeded implements Action {
    readonly type = ActionType.FETCH_REFERENCE_LISTS_SUCCEEDED;
    constructor(readonly payload: Partial<Record<ReferenceListName, ReferenceListItem[]>>) {}
}

export type Actions = FetchReferenceListsSucceeded;
